import React, { useEffect, useState } from "react";
import * as API from "../services/API";
import Footer from "../components/Footer";
import ErrorModal from "../components/ErrorModal";
import "../css/CARepository.css"
import HeaderMembers from "../headers/headerMembers";


function CARepositoryMembers() {
  const [documents, setDocuments] = useState([]);
  const [modalOpen, setModalOpen] = useState(null);
  const [error, setError] = useState(null);

  // Récupération documents
  useEffect(() => {
    API.getCADocumentsMembers(
      (res) => {console.log(res.data);setDocuments(res.data.data)},
      (err) => console.error(err)
    );
  }, []);

    const downloadPDF = (doc) => {
        const link = document.createElement("a");
        link.href = doc.file; // base64 complet déjà formaté
        link.download = `${doc.name}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

  return (
    <>
      <HeaderMembers/>

      <div className="ca-repo-container">
        <h1 className="text-center m-5">Liste des comptes rendus de CA</h1>

        {documents.length === 0 ? (
        <div className="document-empty">
            📂 Aucun document disponible pour le moment.
        </div>
        ) : (
        <div className="pdf-grid">
            {documents.map((doc, index) => (
            <div key={index} className="pdf-card">

                <div className="pdf-icon">
                📄
                </div>

                <div className="pdf-info">
                <div className="pdf-title">
                    {doc.name}
                </div>

                <div className="pdf-actions">
                    <button
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => downloadPDF(doc)}
                    >
                    Télécharger
                    </button>

                </div>
                </div>

            </div>
            ))}
        </div>
        )}

      </div>

      <ErrorModal
        show={!!error}
        message={error}
        onClose={() => setError(null)}
      />

      {modalOpen}

      <Footer />
    </>
  );
}

export default CARepositoryMembers;